import { Controller } from "@hotwired/stimulus"

// Toggles the marketplace results grid between card-grid and list layouts,
// persisting the choice in localStorage so it survives reloads / filter swaps.
export default class extends Controller {
  static targets = ["container", "gridBtn", "listBtn"]
  static values = { storageKey: { type: String, default: "marketplace-view" } }

  connect() {
    this.apply(localStorage.getItem(this.storageKeyValue) || "grid")
  }

  grid() { this.set("grid") }
  list() { this.set("list") }

  set(mode) {
    localStorage.setItem(this.storageKeyValue, mode)
    this.apply(mode)
  }

  apply(mode) {
    if (this.hasContainerTarget) {
      this.containerTarget.classList.toggle("view-list", mode === "list")
    }
    if (this.hasGridBtnTarget) this.gridBtnTarget.classList.toggle("active", mode === "grid")
    if (this.hasListBtnTarget) this.listBtnTarget.classList.toggle("active", mode === "list")
  }
}
